import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class DayModalDataService {

    //default settings
    private messageSource = new BehaviorSubject<string>('default message');
    private modalDateSource = new BehaviorSubject<number>(0);
    private modalMonthSource = new BehaviorSubject<string>('Month Name');
    private modalSignSource = new BehaviorSubject<string>('12');
    private modalFirstQMoonSource = new BehaviorSubject<boolean>(false);
    private modalFirstQMoon2Source = new BehaviorSubject<boolean>(false);
    private modalLastQMoonSource = new BehaviorSubject<boolean>(false);
    private modalLastQMoon2Source = new BehaviorSubject<boolean>(false);

    private modalFullMoonSource = new BehaviorSubject<boolean>(false);
    private modalFullMoon2Source = new BehaviorSubject<boolean>(false);
    private modalNewMoonSource = new BehaviorSubject<boolean>(false);
    private modalNewMoon2Source = new BehaviorSubject<boolean>(false);
    private modalTodaySunSource = new BehaviorSubject<boolean>(false);


    //observale creation
    currentMessage = this.messageSource.asObservable();
    currentModalDate = this.modalDateSource.asObservable();
    currentModalMonth = this.modalMonthSource.asObservable();
    currentModalSign = this.modalSignSource.asObservable();
    currentFirstQMoon = this.modalFirstQMoonSource.asObservable();
    currentFirstQMoon2 = this.modalFirstQMoon2Source.asObservable();
    currentLastQMoon = this.modalLastQMoonSource.asObservable();
    currentLastQMoon2 = this.modalLastQMoon2Source.asObservable();
    
    currentFullMoon = this.modalFullMoonSource.asObservable();
    currentFullMoon2 = this.modalFullMoon2Source.asObservable();
    currentNewMoon = this.modalNewMoonSource.asObservable();
    currentNewMoon2 = this.modalNewMoon2Source.asObservable();

    currentTodaySun = this.modalTodaySunSource.asObservable();



    constructor() { }

    changeMessage(message: string){
        // this.messageSource.next(message);
    }
    changeDate(modalDate: number){
      // this.modalDateSource.next(modalDate);
    }

    changeModalData(modalInfo: any, monthName: string){
      this.messageSource.next('')
      this.modalMonthSource.next(monthName);
      this.modalDateSource.next(modalInfo.todayIs);
      this.modalSignSource.next(modalInfo.signIcon);
      this.modalFullMoonSource.next(false);
      this.modalNewMoonSource.next(false);
      this.modalTodaySunSource.next(false);

      modalInfo.firstqmoon == true ? (this.modalFirstQMoonSource.next(true), this.messageSource.next('The First Quarter Moon')) : this.modalFirstQMoonSource.next(false);
      modalInfo.firstqmoon2 == true ? (this.modalFirstQMoon2Source.next(true), this.messageSource.next('This monnth has another First Quarter Moon')) : this.modalFirstQMoon2Source.next(false);
      modalInfo.lastqmoon == true ? (this.modalLastQMoonSource.next(true), this.messageSource.next('The Last Quarter Moon')) : this.modalLastQMoonSource.next(false);
      modalInfo.lastqmoon2 == true ? (this.modalLastQMoon2Source.next(true), this.messageSource.next('This monnth has another Last Quarter Moon')) : this.modalLastQMoon2Source.next(false);
      modalInfo.newMoon == true ? (this.modalNewMoonSource.next(true), this.messageSource.next("The New Moon")) : this.modalNewMoonSource.next(false);
      modalInfo.newMoon2 == true ? (this.modalNewMoon2Source.next(true), this.messageSource.next("This month has a second New Moon")) : this.modalNewMoon2Source.next(false);
      modalInfo.fullMoon == true ? (this.modalFullMoonSource.next(true), this.messageSource.next(modalInfo.fullmoonName)) : this.modalFullMoonSource.next(false);
      modalInfo.fullMoon2 == true ? (this.modalFullMoon2Source.next(true), this.messageSource.next(modalInfo.fullmoonName2)) : this.modalFullMoon2Source.next(false);
      modalInfo.showTodaySun == true ? this.modalTodaySunSource.next(true) : this.modalTodaySunSource.next(false);
      
      // console.log('changeModalData to', modalInfo);
      // console.log('modal vale check currentFullMoon', this.currentFullMoon)

  }
}
